module.exports = __webpack_public_path__ + "static/media/Rollossimples.274c01d5.jpg";